import _superagent from 'superagent';

export async function captchaVerify(token) {
    try {
        const response = await _superagent
            .post(`${process.env.REACT_APP_API_HOST}/captcha/validate`)
            .send({token: `${token}`})
        ;
        if (response.status === 200) {
            return 200;
        }
        return 500;
    } catch (e) {
        return 500;
    }
}